import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useTenantTerm } from '../../hooks/useTenantTerm';

interface Props {
    /** How many in the queue the spot matches; at least 1. */
    count: number;
    onPickFromQueue: () => void;
    onPickAnyTenant: () => void;
    onCancel: () => void;
}

/** Asked on Nytt hyresavtal for a spot that someone in the queue matches. */
const QueueLeaseChoice: React.FC<Props> = ({ count, onPickFromQueue, onPickAnyTenant, onCancel }) => {
    const term = useTenantTerm();
    return (
    <Alert variant="info" className="queue-lease-choice mt-3 mb-0">
        <div className="mb-2">
            {count} sökande i kön passar platsen. Vill du välja från kön eller bland alla {term.pluralInText.toLowerCase()}?
        </div>
        <div className="d-flex gap-2 flex-wrap">
            <Button variant="primary" size="sm" onClick={onPickFromQueue}>Välj från kön</Button>
            <Button variant="outline-primary" size="sm" onClick={onPickAnyTenant}>Alla {term.plural.toLowerCase()}</Button>
            <Button variant="link" size="sm" onClick={onCancel}>Avbryt</Button>
        </div>
    </Alert>
    );
};

export default QueueLeaseChoice;
